export const featuresNotificationModules = [];
